import { render, staticRenderFns } from "./ParcelPage.vue?vue&type=template&id=1926b7f5&scoped=true"
import script from "./ParcelPage.vue?vue&type=script&lang=js"
export * from "./ParcelPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1926b7f5",
  null
  
)

export default component.exports